<template>
  <PageTemplate alternative>
    <Header mod="uti" />
    <Banner mod="uti" />
    <Videos mod="uti" color="#bdd644" />
    <Structure mod="uti" />
    <Equipments mod="uti" />
    <Certifications mod="uti" />
    <Team mod="uti" />
    <Footer mod="uti" />
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../templates/Page.vue";
import Header from "../../shell/PagesHeader.vue";
import Banner from "../../templates/Banner.vue";
import Videos from "../../templates/Videos.vue";
import Structure from "../../templates/Structure.vue";
import Equipments from "../../templates/Equipments.vue";
import Certifications from "../../templates/Certifications.vue";
import Team from "../../templates/Team.vue";
import Footer from "../../shell/PagesFooter.vue";

export default {
  components: {
    PageTemplate,
    Header,
    Banner,
    Videos,
    Structure,
    Equipments,
    Certifications,
    Team,
    Footer,
  },
};
</script>
